import { apiCall } from './apiService';
import { Student, Class } from '../types';

export interface ClassStudent {
  classId: string;
  studentId: string;
  enrolledAt: Date;
}

export interface StudentWithEnrollment extends Student {
  enrolledAt: Date;
}

export interface ClassWithEnrollment extends Class {
  enrolledAt: Date;
}

const classStudentService = {
  // Get all students in a class
  getStudentsInClass: async (classId: string): Promise<StudentWithEnrollment[]> => {
    return apiCall<StudentWithEnrollment[]>(`/class-students.php/class/${classId}`);
  },

  // Get all classes for a student
  getClassesForStudent: async (studentId: string): Promise<ClassWithEnrollment[]> => {
    return apiCall<ClassWithEnrollment[]>(`/class-students.php/student/${studentId}`);
  },

  // Add student to class
  addStudentToClass: async (classId: string, studentId: string): Promise<void> => {
    return apiCall<void>('/class-students.php', {
      method: 'POST',
      body: JSON.stringify({ classId, studentId }),
    });
  },

  // Remove student from class
  removeStudentFromClass: async (classId: string, studentId: string): Promise<void> => {
    return apiCall<void>('/class-students.php', {
      method: 'DELETE',
      body: JSON.stringify({ classId, studentId }),
    });
  },

  // Get available students (not in a class)
  getAvailableStudents: async (classId: string): Promise<Student[]> => {
    return apiCall<Student[]>(`/class-students.php/available/${classId}`);
  },
};

export default classStudentService;


